// Cape Verde blog post (real content from volunteering.org.au/find-out-more-about-cape-verde/)
const IMGP = "/assets/img/2019-11-Cape-Verde-blog";

export const CAPE_VERDE_POST = {
  slug: "find-out-more-about-cape-verde",
  category: "Blog",
  title: "Find out more about Cape Verde!",
  standfirst:
    "IVI have some exciting new projects in the stunning and unique country of Cape Verde. Never heard of it? Don't worry, this post will tell you everything you need to know about this beautiful African island.",
  author: "Sam Topping",
  role: "IVI Volunteer Manager",
  date: "22 July 2026",
  readTime: "7 min read",
  hero: `${IMGP}.jpg`,
  tags: ["Cape Verde", "Africa", "Destinations", "New Projects"],
  facts: [
    { k: "Country name", v: "Republic of Cabo Verde" },
    { k: "Capital", v: "Praia" },
    { k: "Area", v: "4,033 km² (1,557 sq mi)" },
    { k: "Official languages", v: "Crioulo, Portuguese, English" },
    { k: "Population", v: "560,349" },
    { k: "Time zone", v: "UTC −1" },
    { k: "Currency", v: "Cape Verdean escudo (CVE)" },
    { k: "Electricity", v: "220V / 50Hz (Type C & F)" },
  ],
  sections: [
    {
      id: "where",
      heading: "Where is Cape Verde?",
      paras: [
        "Known in ancient times as “the Islands of the Blessed” or the “Fortunate Isles”, the Cape Verde Islands are known locally as Cabo Verde the “Green Cape”. It is an island country spanning 10 volcanic islands in the central Atlantic Ocean, and forms part of the Macaronesia ecoregion along with the Azores, Canary Islands, Madeira and the Savage Isles.",
        "Located 570 kilometres west of the Cape Verde Peninsula off the coast of Northwest Africa, the islands cover a combined area of slightly over 4,000 square kilometres.",
      ],
      images: [{ src: `${IMGP}-2.jpg`, caption: "Volunteers on a Cape Verde island" }],
    },
    {
      id: "history",
      heading: "A brief history",
      paras: [
        "The Islands of Cape Verde were uninhabited until the Portuguese first landed in 1460. They settled in an area of Santiago which they named Ribeira Grande, and used it as a slave-trade post between Africa and the New World. Selected Africans remained on the island and worked as slaves on the latifundas, or plantations.",
        "After several pirate attacks, Ribeira Grande was abandoned following a French assault in 1712. With the decline of the slave trade in 1876 the islands lost much of their economic value to the Portuguese, but regained wealth in the late nineteenth century thanks to their location on major trade routes between Europe, South America and Africa, and the opening of a coal and submarine cable station in the port city of Mindelo.",
      ],
      images: [
        { src: `${IMGP}-10.jpg`, caption: "Cape Verde island" },
        { src: `${IMGP}-9.jpg`, caption: "Coastal village life" },
      ],
    },
    {
      id: "food-culture",
      heading: "Food & culture",
      paras: [
        "Although Portuguese colonial culture dominated Cape Verde for centuries, African and South American traditions have blended with the traditional roots of Cape Verde to create a unique and lively culture today. The people are a mix of Portuguese and African descent, and most speak Crioulo a blend of Portuguese and West African languages.",
        "The way of the Cape Verdean people, called “Morabeza”, is a way of life. People are always with a smile on their face; friendly, welcoming and very hospitable. It is their nature of being an open spirit and having a calm, relaxed lifestyle that brings Morabeza to all corners of Cape Verde.",
        "The national dish “Cachupa” is a slow-cooked, hearty stew made with beans, corn kernels, vegetables and fish or meat. “Canjo”, a thick chicken soup with rice, onions and carrots, is another local delicacy. Braised meats are common, but fresh fish and seafood dishes are the true speciality washed down with Cape Verdean beers, wines or the traditional brandy called “Grogu”.",
      ],
      images: [
        { src: `${IMGP}-8.jpg`, caption: "Cape Verdean cooking" },
        { src: `${IMGP}-7.jpg`, caption: "Local dishes and fresh seafood" },
      ],
    },
    {
      id: "climate",
      heading: "Climate",
      paras: [
        "Having a decent tropical climate all year round, Cape Verde is cooler than most of West Africa. Tropically dry, average daytime highs range from about 20 to 28 degrees Celsius, with the warmer temperatures falling from May to November. It's good weather all year for hiking and swimming, although nights can get chilly from December through March.",
      ],
      images: [],
    },
    {
      id: "things-to-do",
      heading: "Things to do and places to go",
      paras: [
        "Tarrafal, in the north of the island of Santiago, is a very quiet and safe place where you can go out and have fun with friends or make new ones very easily. It has a beautiful beach to relax on, and being such a calm place you'll find the people are friendly and everyone knows each other. Trekking, snorkelling and water sports are all on the doorstep, and the local museum gives you an insight into the history of Cape Verde. The only means of transport to Tarrafal from the capital, Praia, is the collective where you get to see how life in Cape Verde is simple and friendly.",
        "Beyond that: horseback riding at Santa Maria beach, swimming in the warm pools of the Pedra Lume Crater, learning to kite surf at Kite Beach on Sal Island, dune bashing and sea turtle tours in Boa Vista, exploring Santo Antão Island, wandering the coast of Baia Das Gatas on São Vicente, and hiking the trails of Fogo Island. Each island serves up a different set of attractions and each feels vastly different from the last.",
      ],
      images: [
        { src: `${IMGP}-6.jpg`, caption: "Cape Verde beach" },
        { src: `${IMGP}-5.jpg`, caption: "Island streets" },
        { src: `${IMGP}-4.jpg`, caption: "Volcanic landscapes" },
        { src: `${IMGP}-3.jpg`, caption: "Island life" },
      ],
    },
    {
      id: "transport",
      heading: "Transportation",
      paras: [
        "There are regular flights to and from the major islands (Santiago, Sal, São Vicente and Boa Vista), with less frequent flights to some of the others. Boat and ferry transport is also available island to island. Within the islands, public buses run periodically and taxis are common in the large cities; in smaller towns there are public vans and taxis you can hire.",
      ],
      images: [],
    },
  ],
  closing:
    "All in all famous for its volcanic islands, wonderful musicians, delicious cuisine, friendly people and warm tropical climate Cape Verde is an astonishing place to visit. Stay tuned for info on our new projects in Cape Verde!",
};

export const RELATED_POSTS = [
  {
    title: "Things to do in Cape Verde: a volunteer's guide to Tarrafal and beyond",
    path: "/things-to-do-in-cape-verde-a-volunteers-guide-to-tarrafal-and-beyond/",
    img: "/assets/img/2019-11-Cape-Verde-blog-6.jpg",
    date: "25 July 2026",
    cat: "Guides",
  },
  {
    title: "Best volunteer programs in Africa a full comparison",
    path: "/best-volunteer-programs-in-africa-a-full-comparison/",
    img: "/assets/img/2020-02-Group-photo-at-tea-farm-1.jpg",
    date: "22 July 2026",
    cat: "Comparison",
  },
  {
    title: "Reasons why you should volunteer in Africa",
    path: "/reasons-why-you-should-volunteer-in-africa-in-2023-2024/",
    img: "/assets/img/2019-12-Sports-coaching-ghana-9.jpg",
    date: "18 July 2026",
    cat: "Blog",
  },
  {
    title: "Best wildlife and marine volunteer programs with IVI",
    path: "/best-wildlife-and-marine-volunteer-programs-with-ivi/",
    img: "/assets/img/2016-02-turtle-1.jpg",
    date: "14 July 2026",
    cat: "Wildlife",
  },
  {
    title: "A guide to solo female travel volunteering overseas",
    path: "/a-guide-to-solo-female-travel-volunteering-overseas/",
    img: "/assets/img/2025-10-Mangochi-Teaching-11-3-768x1024.jpg",
    date: "9 July 2026",
    cat: "Tips",
  },
  {
    title: "Quick tips for packing for your volunteer trip",
    path: "/quick-tips-for-packing-for-your-volunteer-trip/",
    img: "/assets/img/2022-12-Modern-eBook-Mockup-for-Coaches-Facebook-Post-2-min.webp",
    date: "2 July 2026",
    cat: "Tips",
  },
  {
    title: "Elephant conservation in Koh Samui a volunteer's week",
    path: "/review-elephant-conservation-koh-samui/",
    img: "/assets/img/2025-03-Koh-Samui-Elephant-Care-Program-16-600x800.jpg",
    date: "29 June 2026",
    cat: "Wildlife",
  },
  {
    title: "Cheetah conservation in Cape Town: what you actually do",
    path: "/cheetah-conservation-review-south-africa/",
    img: "/assets/img/2025-05-Cheetah-feeding.jpg",
    date: "24 June 2026",
    cat: "Wildlife",
  },
  {
    title: "Teaching English in Cusco, 3,800 metres up",
    path: "/teaching-in-peru-review-2/",
    img: "/assets/img/2025-05-p1-2-555x1024.jpg",
    date: "19 June 2026",
    cat: "Teaching",
  },
  {
    title: "A 3-week road trip and soup kitchen in Vietnam",
    path: "/3-week-road-trip-in-vietnam-review/",
    img: "/assets/img/2025-01-cooking.jpg",
    date: "12 June 2026",
    cat: "Road Trips",
  },
  {
    title: "Turtle conservation on Nusa Penida beach cleans at dawn",
    path: "/turtle-conservation-nusa-penida-review/",
    img: "/assets/img/2024-11-beach-clean.jpg",
    date: "6 June 2026",
    cat: "Conservation",
  },
  {
    title: "Rehabilitating stray dogs in Kathmandu",
    path: "/projects/nepal/stray-dog-rehabilitation/",
    img: "/assets/img/2023-01-volunteer-with-dog-in-nepal-min-1.webp",
    date: "30 May 2026",
    cat: "Animals",
  },
  {
    title: "Kindergarten teaching in Ubud: a week in the life",
    path: "/review-of-kindergarten-project-in-ubud/",
    img: "/assets/img/2023-06-06216910-31CD-49A3-A7B2-CC4A093D750A-1-min-1-1024x768.webp",
    date: "22 May 2026",
    cat: "Teaching",
  },
  {
    title: "Working with animals in Fiji shelters and outreach clinics",
    path: "/fiji-animals-review/",
    img: "/assets/img/2023-10-puppies-1-1024x768.webp",
    date: "15 May 2026",
    cat: "Animals",
  },
  {
    title: "How to create a lesson plan for teaching overseas",
    path: "/how-to-create-a-lesson-plan-for-teaching-overseas/",
    img: "/assets/img/2020-04-Participant-teaching-animal-names-in-English-with-drawings-min-1.webp",
    date: "8 May 2026",
    cat: "Guides",
  },
  {
    title: "Medical internships abroad: what to expect",
    path: "/medical-internships-abroad-what-to-expect/",
    img: "/assets/img/2020-03-medical-guatemala-1-1024x576.jpeg",
    date: "1 May 2026",
    cat: "Medical",
  },
  {
    title: "Volunteering as a family: what we learned in Fiji",
    path: "/teaching-in-fiji-as-a-family-of-4/",
    img: "/assets/img/2017-01-photo2-1-300x225.jpg",
    date: "24 April 2026",
    cat: "Family",
  },
];
